import React from 'react'
import CodeMirror from '@uiw/react-codemirror'
import { IconButton } from 'transfix-ui/components/IconButton'
import { Box, Button, makeStyles, Typography } from 'transfix-ui/core'
import { IBuilderLibraries, IStupidEdiConfigs, Maybe } from 'types/graphqlTypes'
import { SettingsIcon } from 'transfix-icons'

interface IRunBuilderContainerProps {
  extractionTemplate: string
  builderLibrary: IBuilderLibraries
  stupidediConfig: Maybe<IStupidEdiConfigs>
  tfx12DefinitionId: Maybe<string>
  extractionTemplateChangeHandler: (value: string) => void
  runQueryHandler: (
    extractionTemplate: string,
    builderLibrary: IBuilderLibraries,
    stupidediConfig: Maybe<IStupidEdiConfigs>,
    tfx12DefinitionId: Maybe<string>
  ) => void
  settingsClickHandler: () => void
}

const useStyles = makeStyles(theme => ({
  editor: {
    borderRight: '1px solid',
    '& .cm-content': {
      border: '1px solid',
      borderRight: 'none',
      fontFamily: 'monospace',
    },
    '& .cm-lineNumbers': {
      minWidth: 33,
    },
    '& .cm-line::selection': {
      backgroundColor: '#d9d9d9 !important',
    },
  },
  column: {
    flex: 5,
  },
  columnLarge: {
    flex: 7,
  },
  runQueryButton: {
    marginRight: theme.spacing(1),
  },
}))

export const RunBuilderContainer = ({
  builderLibrary,
  extractionTemplate,
  extractionTemplateChangeHandler,
  runQueryHandler,
  settingsClickHandler,
  stupidediConfig,
  tfx12DefinitionId,
}: IRunBuilderContainerProps) => {
  const classes = useStyles()
  const runBuilderHandler = () => {
    runQueryHandler(extractionTemplate, builderLibrary, stupidediConfig, tfx12DefinitionId)
  }

  return (
    <Box className={`${classes.column} ${classes.columnLarge}`} marginX={2}>
      <Box
        marginY={1}
        display='flex'
        flexDirection='row'
        flexWrap='wrap'
        justifyContent='space-between'>
        <Typography variant='h3'>Enter your query here:</Typography>
        <Box>
          <Button className={classes.runQueryButton} onClick={runBuilderHandler}>
            Run Builder
          </Button>
          <IconButton
            Icon={SettingsIcon}
            color='secondary'
            onClick={settingsClickHandler}
            size='large'
          />
        </Box>
      </Box>
      <CodeMirror
        height='40vh'
        maxWidth='70vw'
        className={classes.editor}
        value={extractionTemplate}
        onChange={extractionTemplateChangeHandler}
      />
    </Box>
  )
}
